// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1N0Mp","label":"SetPasswdForm_label__12F-S"};